import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import useRights from './useRights';

const useAuthorization = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { haveRouteAccess } = useRights();

  React.useEffect(() => {
    if (!haveRouteAccess(location.pathname)) {
      navigate('/');
    }
  }, [location, navigate, haveRouteAccess]);

  return null;
};

export default useAuthorization;
